module.exports = __webpack_public_path__ + "media/images/flf-texture_natural-97df02b68b5acbb9f2209fd024d25fea.jpg";